import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  justify-content: space-between;
  padding: 19px 32px;
`

const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`

const Space = styled.div`
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:after {
    content: '...';
  }
`

const Content = styled.div`
  margin: 0 0 0 10px;
`

export const s = { Container, Buttons, Space, Content }
